export default __webpack_public_path__ + "static/media/guide0203_m.47e1fc0c.jpg";